import { ID } from 'shared/types/id';
import { WordId } from 'shared/utils/nlp/get-ids-for-words';
import { getWordIndexFromMatch } from 'shared/utils/nlp/get-word-index-for-match';

export const isInsideIgnoredRange = (
  match: RegExpMatchArray,
  { ignoredWordIds, wordIds }: { ignoredWordIds: ID[]; wordIds: WordId[] },
) => {
  const wordIndex = getWordIndexFromMatch(match, wordIds);
  const wordId = wordIds[wordIndex]?.id;
  return wordId ? ignoredWordIds.includes(wordId) : false;
};

export const escapeRegex = (str: string) =>
  str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
